import React from "react";
import { useOrdinancesObjEdit } from "./OrdinancesPage";
import { useSelector } from "react-redux";
import { RootState } from "../../../BusinessObjects/Redux/app/store";
import { Box, Button } from "@mui/material";
import RenderFormNew from "../../../Components/Esaedro/RenderForm/RenderFormNew";
import { useNavigate } from "react-router-dom";
import { RoutePath } from "../../../Utils/RoutePath";
import { Form } from "../../../Models/SysConf/Form";
import { useQuery } from "react-query";
import { ResourceNames } from "../../../Utils/ResourceNames";
import cubeApiClient from "../../../BusinessObjects/cubeApiService";
import notify from "devextreme/ui/notify";

type Props = {};

const OrdinanancesEdit = (props: Props) => {
  // Redux
  const tokenApi = useSelector((state: RootState) => state.user.tokenAPI);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);

  //React Router Dom
  const { objEdit, setObjEdit } = useOrdinancesObjEdit();
  const navigate = useNavigate();

  // Chiamate Api
  const {
    data: resourcesViewsSortFields,
    isLoading: isLoadingResourcesViewsSortFields,
    isError: isErrorResourcesViewsSortFields,
    refetch: refetchResourcesViewsSortFields,
    isRefetching: isRefetchingResourcesViewsSortFields,
  } = useQuery(
    ["resourcesViewsSortFields", objEdit?.View_ID, tokenApi],
    () => {
      var urlToUse = `api/sys/${ResourceNames.ResourcesViewsSortFields}?RecordSelection=View_ID=${objEdit?.View_ID}`;
      const service = new cubeApiClient();

      return service.getItems(urlToUse, tokenApi);
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const {
    data: formResourcesViewsSortFields,
    isLoading: isLoadingFormResourcesViewsSortFields,
  } = useQuery(
    [
      "form",
      ResourceNames.ResourcesViewsSortFields,
      userProfile?.customer_ID,
      tokenApi,
    ],
    () => {
      const service = new cubeApiClient();

      return service
        .getItems(
          `api/sys/${ResourceNames.Resources}?RecordSelection=ResourceName='${ResourceNames.ResourcesViewsSortFields}'`,
          tokenApi
        )
        .then(
          (data: any) => {
            let urlForm = `api/sys/${ResourceNames.Forms}/query?ResourceId=${data[0].Resource_ID}`;

            return service.getItems(urlForm, tokenApi).then(
              (data: any) => {
                return data[0];
              },
              (error: any) => {
                return undefined;
              }
            );
          },
          (error: any) => {
            return undefined;
          }
        );
    },
    {
      enabled: isLoggedIn,
      refetchOnWindowFocus: false,
      retry: 0,
      refetchInterval: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchIntervalInBackground: false,
    }
  );

  const formResourceViewSortField: Form | undefined = React.useMemo(() => {
    if (formResourcesViewsSortFields) {
      let tmpForm: Form = formResourcesViewsSortFields;

      tmpForm.FormsGroups.forEach((fg) => {
        fg.FormsFields.forEach((ff) => {
          if (ff.FieldName === "View_ID") {
            ff.Is_Editable = false;
          }
        });
      });

      return tmpForm;
    }

    return undefined;
  }, [formResourcesViewsSortFields]);

  // Chiamata per salvare un nuovo ordinamento
  const saveNewResourceViewSortField = () => {
    const service = new cubeApiClient();

    service
      .updateObject(
        objEdit,
        `api/sys/${ResourceNames.ResourcesViewsSortFields}`,
        tokenApi
      )
      .then(
        (data) => {
          refetchResourcesViewsSortFields();
          navigate(
            `${RoutePath.RESOURCES_VIEWS}/${objEdit?.View_ID}/ordinances`
          );
          notify("Ordinamento salvato con successo", "success", 1000);
        },
        (error) => {
          refetchResourcesViewsSortFields();
          notify("Errore nel salvataggio dell'ordinamento", "error", 1000);
        }
      );
  };

  // ! Inizio del DOM
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          justifyContent: "space-around",
          alignItems: "center",
          mt: 1,
          flexDirection: "row",
          mb: 3,
        }}
      >
        <React.Fragment>
          <RenderFormNew
            showTitle={false}
            isNew={false}
            form={formResourceViewSortField}
            myObj={objEdit}
            saveNewObject={(e) => setObjEdit(e)}
          />
        </React.Fragment>
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          mt: 1,
          flexDirection: "row",
        }}
      >
        <Button
          variant="contained"
          color="error"
          className="me-2"
          onClick={() =>
            navigate(
              `${RoutePath.RESOURCES_VIEWS}/${objEdit?.View_ID}/ordinances`
            )
          }
        >
          Annulla
        </Button>
        <Button
          variant="contained"
          color="success"
          onClick={() => saveNewResourceViewSortField()}
        >
          Salva
        </Button>
      </Box>
    </>
  );
};

export default OrdinanancesEdit;
